import React from "react";

import { Button } from "../../Button";
import { clickAnalytics } from "../../../components/Common/InsuranceEligibility/signup_analytics";
import { Text } from "../../Text";
import { TextTypes, TextColors } from "../../constants";

import "./styles.scss";

// Relates to: Self Signup

export const VerifyInsuranceDeclined = ({ insuranceName, insuranceURL, prevStep, step, title }) => {
  return (
    <div className="apti-VerifyInsurance">
      <Text color={TextColors.green} type={TextTypes.heading1}>
        {title}
      </Text>
      <Text className="details">
        For questions about your coverage, please contact&nbsp;
        {insuranceURL.length > 0 && (
          <a
            className="bold green link"
            href={insuranceURL}
            onClick={() => clickAnalytics("self_signup", "declined", "payor")}
            rel="noreferrer"
            target="_blank"
          >
            {" "}
            {insuranceName}
          </a>
        )}
        {insuranceURL.length === 0 && (
          <>
            <span className="bold green"> {insuranceName}</span>
          </>
        )}
        .
      </Text>
      <Button
        className="link"
        onClick={() => {
          clickAnalytics("self_signup", "declined", "back");
          prevStep();
        }}
      >
        Back to Insurance
      </Button>
    </div>
  );
};

VerifyInsuranceDeclined.defaultProps = {
  insuranceName: "",
  insuranceURL: "",
  prevStep: () => {},
  title: "",
};
